
import React      from 'react';
import CSSModules from 'react-css-modules';

import { GoogleMapLoader, GoogleMap, Marker, InfoWindow } from 'react-google-maps';

import style from './style.scss';

import eventFormatter from '../../services/eventFormatter';

import EventPreview from '../EventPreview';

import { browserHistory } from 'react-router'

class SideBarMap extends React.Component {

    constructor() {

        super();

        this.state = {
            openInfoWindows: []
        };
    }
    
    _getContainer() {
        
        return (
            <div { ...this.props } className={ style['map-container'] }></div>
        );
    }

    _setMapBounds(map, events) {

        var bounds = new google.maps.LatLngBounds();

        events.forEach((event) => {

            if (event.venue && event.venue.address) {

                const { latitude, longitude } = event.venue.address;

                bounds.extend(new google.maps.LatLng(latitude, longitude));
            }
        });

        if (!bounds.isEmpty()) {

            map.fitBounds(bounds);
        }
    }

    _setMapReference(map) {

        if (map && !this.map) {

            this.map = map;
        }
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.events && nextProps.events.length > 0) {

            this._setMapBounds(this.map, nextProps.events);
        }
    }

    _isShowingInfoWindow(eventId) {

        return this.state.openInfoWindows.includes(eventId);
    }

    _navigateToEventDetail(eventId) {

        browserHistory.push(`/events/${ eventId }`);
    }

    _navigateToBooking(eventId) {

        browserHistory.push(`/booking/${ eventId }`);
    }

    _getInfoWindow(event) {

        if (this._isShowingInfoWindow(event.id)) {

            const formattedEvent = eventFormatter.format(event);

            return (
                <InfoWindow onCloseclick={ this._hideInfoWindow.bind(this, event.id) }>

                    <div>

                        <EventPreview size="small" event={ formattedEvent } />

                        <div className={ style['button-panel'] }>

                            <a onClick={ this._navigateToEventDetail.bind(this, event.id) }
                               className={ style['action-button'] }>
                                Details
                            </a>

                            <a onClick={ this._navigateToBooking.bind(this, event.id) }
                               className={ style['action-button'] }
                               disabled={ event.fully_booked }>
                                Booking
                            </a>

                        </div>

                    </div>

                </InfoWindow>
            );
        }
    }

    _hideInfoWindow(eventId) {

        const openInfoWindows = this.state.openInfoWindows.filter((id) => {

            return id !== eventId;
        });

        this.setState({
            openInfoWindows
        });
    }

    _showInfoWindow(eventId) {

        const openInfoWindows = this.state.openInfoWindows.concat(eventId);

        this.setState({
            openInfoWindows
        });
    }

    _getMarker(hexCode) {

        return {
            path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
            fillColor: hexCode,
            fillOpacity: 1,
            strokeColor: '#a5a5a5',
            strokeWeight: 1,
            scale: 1,
        };
    }

    _getMap() {

        return (
            <GoogleMap ref={ this._setMapReference.bind(this) }
                       defaultZoom={ 5 }
                       defaultOptions={{ mapTypeControl: false, streetViewControl: false }}
                       defaultCenter={{ lat: 55.378024, lng: -3.436035 }}>

                {
                    this.props.events.map((event, index) => {

                        if (event.venue && event.venue.address) {

                            const markerPosition = {
                                lat: parseFloat(event.venue.address.latitude),
                                lng: parseFloat(event.venue.address.longitude)
                            };

                            return (

                                <Marker key={ index }
                                        icon={ this._getMarker(event.course.module.hex_colour) }
                                        onClick={ this._showInfoWindow.bind(this, event.id) }
                                        position={ markerPosition }>

                                    { this._getInfoWindow(event) }

                                </Marker>
                            );
                        }
                    })
                }
                
            </GoogleMap>
        );
    }

    render() {

        return (
                <GoogleMapLoader containerElement={ this._getContainer() }
                                 googleMapElement={ this._getMap() } />

        );
    }
}

export default CSSModules(SideBarMap, style);


// WEBPACK FOOTER //
// ./components/SideBarMap/index.js